import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket, faXmark } from "@abodeminehq/parcel-ui/icons/fa/pro-solid";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Logo,
} from "@abodeminehq/parcel-ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/mcp/auth/signed-out")({
  component: McpSignedOutPage,
});

function McpBrandHeader() {
  return (
    <div className="flex items-center justify-center gap-3">
      <Logo size="lg" />
      <FontAwesomeIcon icon={faXmark} className="h-4 w-4 text-muted-foreground" />
      <img src="/logos/mcp.webp" alt="MCP" className="h-8 w-auto" />
    </div>
  );
}

function McpSignedOutPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="w-full max-w-lg">
        <CardHeader className="text-center">
          <div className="mx-auto mb-2">
            <McpBrandHeader />
          </div>
          <div className="mx-auto mb-2">
            <FontAwesomeIcon icon={faArrowRightFromBracket} className="h-10 w-10 text-muted-foreground" />
          </div>
          <CardTitle>Signed Out</CardTitle>
          <CardDescription>
            You have been signed out of Abodemine MCP.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground text-center">
            To sign in again, reconnect the MCP server from your client. The
            login flow will restart automatically.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
